import { render, staticRenderFns } from "./UserFamilyParents.vue?vue&type=template&id=058fc472&"
import script from "./UserFamilyParents.vue?vue&type=script&lang=js&"
export * from "./UserFamilyParents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports